import {useCallback} from 'react';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';

/**
 * Runs a memory mutation, alerting on failure (and on success when a message is given).
 * @registry Scout memory mutation runner with success/error alerts; resolves true on success.
 */
export const useMemoryRequest = () => {
  const {setAlert} = useAlert();

  return useCallback(
    async (request: () => Promise<unknown>, success?: string) => {
      try {
        await request();
        if (success) setAlert(success, 'success');
        return true;
      } catch (error) {
        setAlert(parseErrorMessage(error), 'error');
        return false;
      }
    },
    [setAlert]
  );
};
